import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SpatialAudioIcon(props: IconProps) {
    return <Icon {...props} iconKey={"spatial_audio"}/>
}
